import { FC, useState, ChangeEvent, useEffect } from 'react';
import { useStyles } from './styles';
import { SearchProps } from './types';
import { TextField, InputAdornment, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import { useStore } from 'hooks/useRootStore';
import { useLocation } from 'react-router-dom';
import { useAppPreloader } from 'hooks/useAppPreloader';

export const Search: FC<SearchProps> = ({ handelSearch }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const Location = useLocation();
  const {
    ldapStore: { setFilterateRoute, getUsers },
  } = useStore();
  const [search, setSearch] = useState<string>('');
  const [debouncedSearch, setDebouncedSearch] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  // Check if we're on logs page
  const isLogsPage = Location.pathname.includes('/reports');

  useEffect(() => {
    handelSearch('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const delay = setTimeout(
      () => {
        setDebouncedSearch(search);
      },
      isLogsPage ? 300 : 500
    ); // Faster debounce for logs
    return () => clearTimeout(delay);
  }, [search, isLogsPage]);

  useEffect(() => {
    if (isLogsPage) {
      handelSearch(debouncedSearch);
      return;
    }

    // Original logic for other pages
    const pathSegments = Location.pathname.split('/').filter((segment) => segment !== '');
    const route = pathSegments[0] || '';

    setFilterateRoute(route, debouncedSearch);
    handelSearch(debouncedSearch);
    if (route === 'users') {
      setLoading(true);
      getUsers()
        .then(() => {
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch, isLogsPage]);

  const handelClear = () => {
    if (isLogsPage) {
      setSearch('');
      handelSearch('');
      return;
    }

    // Original logic for other pages
    const pathSegments = Location.pathname.split('/').filter((segment) => segment !== '');
    const route = pathSegments[0] || '';

    setFilterateRoute(route, '');
    setSearch('');
    handelSearch('');
  };

  const handleChange = (event: ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    setSearch(value);

    if (isLogsPage) {
      // For logs, don't call handelSearch immediately, let debounce handle it
      return;
    }

    // Original logic for other pages
    const pathSegments = Location.pathname.split('/').filter((segment) => segment !== '');
    const route = pathSegments[0] || '';

    handelSearch(value);
    setFilterateRoute(route, value);
    setLoading(true);
  };

  useAppPreloader(loading && !isLogsPage);

  return (
    <div className={classes.centerHeadBox}>
      <TextField
        className={classes.searchInput}
        placeholder={isMobile ? 'Search...' : 'Search'}
        value={search}
        onChange={handleChange}
        size={isMobile ? 'small' : 'medium'}
        InputProps={{
          startAdornment: (
            <SearchIcon
              style={{
                color: 'grey',
                fontSize: isMobile ? '18px' : '20px',
              }}
            />
          ),
          endAdornment: (
            <InputAdornment position='end'>
              {search ? (
                <IconButton size={isMobile ? 'small' : 'medium'} onClick={handelClear}>
                  <ClearIcon
                    style={{
                      color: 'red',
                      fontSize: isMobile ? '16px' : '18px',
                    }}
                  />
                </IconButton>
              ) : (
                ' '
              )}
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};
